// IBM Plex, Latin subset, bundled with the app (see the comment in fonts.css).
import './assets/fonts/fonts.css';

import { bootstrap } from './app/bootstrap';
import { readRuntimeConfig } from './lib/config/runtime-config';
import { createWebAppTelegramPort } from './lib/telegram/web-app-telegram-port';

// Fail fast on a broken deployment: the runtime config is checked before anything renders.
const config = readRuntimeConfig(window);

const container = document.getElementById('root');
if (container === null) throw new Error('#root element missing in index.html');
const root = container;

async function start(): Promise<void> {
  let telegram = createWebAppTelegramPort(window);
  // Dev only: the API is another repository (Q68), so `pnpm dev` answers from the contract
  // mocks (C1) and fakes the Telegram launch data. Vite drops this branch, MSW and the fixtures
  // from the production bundle. `?live` skips the mocks and talks to the real API of
  // `public/config.js`, with the Telegram launch data read from the URL hash like the real client
  // (a joint run on a development machine, see src/dev/README.md).
  if (import.meta.env.DEV && !new URLSearchParams(window.location.search).has('live')) {
    const { startMockApi } = await import('./dev/mock-api');
    const { withMockInitData } = await import('./dev/mock-telegram');
    await startMockApi(config.apiOrigin, window.location.search);
    telegram = withMockInitData(telegram, window.location.search);
  }
  bootstrap(root, telegram, {
    apiOrigin: config.apiOrigin,
    features: { confirmationModeEnabled: config.confirmationModeEnabled },
  });
}

void start();
